<template>
    <div class="form-group">
        <label
            :for="id"
            :data-test-id="`${dataTestIdPrefix}-title`"
            >{{ label }}</label
        >
        <input
            :id="id"
            :value="modelValue"
            :data-test-id="`${dataTestIdPrefix}-textbox`"
            :disabled="disabled"
            :minlength="radioType.serialNumberMinLength"
            :maxlength="radioType.serialNumberMaxLength"
            :pattern="radioType.serialNumberRegex"
            :placeholder="radioType.serialNumberPlaceholder"
            :required="required"
            type="text"
            @input="$emit('update:modelValue', $event.target.value)"
        />
        <div
            :data-test-id="`${dataTestIdPrefix}-help`"
            class="help"
        >
            {{ radioType.serialNumberHelperText }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            required: true,
        },
        dataTestIdPrefix: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: () => false,
        },
        required: {
            type: Boolean,
            default: () => false,
        },
        modelValue: {
            type: [String, null],
            required: true,
        },
        radioType: {
            type: Object,
            required: true,
        },
    },

    emits: ['update:modelValue'],
}
</script>
